import { ITypeSwitcherLocalStorage, TYPE_SWITCHER_LOCALSTORAGE } from '../types';

export const setTypeSwitcherLocalStorage = (
    typeSwitcherLocalStorage: ITypeSwitcherLocalStorage
) => {
    localStorage.setItem(TYPE_SWITCHER_LOCALSTORAGE, JSON.stringify(typeSwitcherLocalStorage));
}
